const en = {
  nav: {
    about: "About",
    about_diego: "About Diego",
    trips: "My trips",
    plan: "Plan",
    new_trip: "Plan a trip",
    login: "Log in",
    register: "Get started",
    account: "My account",
    logout: "Log out",
    admin: "Admin",
    install: "Install",
  },
  pwa: {
    install: "Install",
    ios_title: "Install Voyage-r",
    ios_step1_pre: "Tap the",
    ios_step1_btn: "Share",
    ios_step1_post: "icon at the bottom of Safari",
    ios_step2_pre: "Scroll and tap",
    ios_step2_btn: "Add to Home Screen",
    ios_step3_pre: "Confirm by tapping",
    ios_step3_btn: "Add",
  },
  landing: {
    about: "About",
    my_trips: "My trips",
    login: "Log in",
    start: "Get started",
    hero_label: "Tailor-made trip planning",
    hero_title1: "Travel carefree.",
    hero_title2: "I handle everything.",
    hero_desc: "Describe your trip in 5 minutes. I design your custom itinerary, day by day. And I personally validate every detail before it reaches you.",
    hero_cta: "Plan my trip",
    hero_secondary: "Who is Diego?",
    hero_note: "Free to start · From €29 to unlock your validated itinerary",
    hero_photo: "Every trip has its own story",
    hero_price: "From €29",
    hero_price_sub: "one-time payment",
    features_label: "Why Voyage-r?",
    features_title: "A travel agency,",
    features_title_em: "in your pocket",
    feat1_title: "A fully tailored itinerary",
    feat1_desc: "Your expert advisor analyzes your desires, budget and pace to design a unique trip — not a copy-pasted tourist guide.",
    feat2_title: "Validated by a true enthusiast",
    feat2_desc: "Diego, expert in Africa, the Indian Ocean and authentic Europe, personally reviews every itinerary before you access it.",
    feat3_title: "Everything, really everything included",
    feat3_desc: "Detailed budget, practical info, monthly weather, currency converter, pre-filled booking links.",
    feat4_title: "Your personal travel advisor",
    feat4_desc: "With the Sérénité plan, a dedicated advisor knows your itinerary inside out — ask anything, anytime.",
    steps_label: "The process",
    steps_title: "Four steps to adventure",
    step1_title: "Describe your trip",
    step1_desc: "Fill out a form in 5 minutes: destination, dates, deep desires and total budget.",
    step2_title: "Your file takes shape",
    step2_desc: "Your expert advisor composes a day-by-day itinerary, rich, precise and enthusiastic.",
    step3_title: "Diego validates and refines",
    step3_desc: "Your human expert reviews every detail and gives the go-ahead before delivery.",
    step4_title: "Your trip, unlocked",
    step4_desc: "Choose the plan that suits you — and travel carefree. We handle everything.",
    plans_label: "Our plans",
    plans_title: "Choose your level of support",
    plans_subtitle: "One-time payment per trip · Permanent access throughout the trip + 15 days",
    per_trip: "per trip",
    popular: "Most popular",
    plan_cta: "Choose this plan",
    plans_footer: "Creating your trip file is free. You choose your plan only after Diego's validation.",
    expert_label: "Your expert",
    expert_title: "A true enthusiast",
    expert_title_em: "behind every trip",
    expert_quote: "\"It all began barefoot on African trails. I grew up with the horizon as my only limit.\"",
    expert_desc: "Benin, Réunion, Morocco, Madagascar — Diego has spent his life exploring. Today, he puts that experience at the service of your adventures.",
    expert_photo_caption: "Diego, somewhere in the Indian Ocean",
    expert_cta: "Read his story",
    footer_tos: "Terms",
    footer_privacy: "Privacy",
    footer_contact: "Contact",
    footer_tagline: "Custom-designed travel · Validated by a human expert",
  },
  auth: {
    login_title: "Welcome back, traveler",
    login_subtitle: "Your adventures await",
    email: "Email",
    password: "Password",
    email_placeholder: "you@example.com",
    password_placeholder: "Your password",
    login_btn: "Log in",
    login_loading: "Logging in...",
    no_account: "First adventure?",
    create_account: "Create a free account",
    error_default: "Incorrect email or password",
    welcome_back: "Welcome back!",
    register_title: "Begin your odyssey",
    register_subtitle: "Free to start · From €29 to unlock",
    name: "Full name",
    name_placeholder: "John Smith",
    register_btn: "Create my free account",
    register_loading: "Creating account...",
    tos: "By signing up, you agree to our terms of use.",
    already_member: "Already a member?",
    login_link: "Log in",
    welcome: "Welcome to Voyage-r! Your adventure starts here.",
    password_min: "Password must be at least 6 characters",
    error_register: "Error during registration",
  },
  dashboard: {
    label: "Dashboard",
    title: "My trips",
    greeting: "Hello, {name} — every trip is a new chapter",
    new_trip: "New trip",
    empty_title: "Ready for your first adventure?",
    empty_desc: "Your advisor prepares everything — itinerary, budget, practical info.",
    empty_cta: "Plan my first trip",
    error_load: "Unable to load your trips",
    delete_confirm: "Permanently delete this trip?",
    delete_success: "Trip deleted",
    delete_error: "Error deleting trip",
    see_trip: "See trip",
    since: "From",
    traveler: "traveler",
    travelers: "travelers",
    status_pending: "pending",
    status_unlock: "to unlock",
    status_unlocked: "unlocked",
    status_expired: "expired",
    status_planned: "planned",
  },
  plan: {
    step_label: "Step {n} of {total}",
    step1: "The trip",
    step2: "Your desires",
    step3: "Personalization",
    step4: "Generation",
    step1_title: "The trip",
    step1_subtitle: "Your advisor handles everything — fill in what you know, leave the rest blank.",
    dep_city: "Departure city *",
    dep_placeholder: "London, New York, Paris...",
    destination: "Destination",
    dest_hint: "(blank = your advisor suggests)",
    dest_placeholder: "Tokyo, Bali, Marrakech...",
    dep_date: "Departure date *",
    ret_date: "Return date *",
    adults: "Adults",
    children: "Children",
    budget: "Total budget",
    trip_type: "Trip type",
    next: "Continue",
    step2_title: "Your desires",
    step2_subtitle: "Select what appeals to you — your advisor will take it into account.",
    ambiances: "Desired vibes",
    accommodation: "Preferred accommodation",
    pace: "Travel pace",
    gastronomy: "Gastronomy",
    transport: "Local transport",
    prev: "Back",
    step3_title: "Personalization",
    step3_subtitle: "The more you tell us, the more perfect the itinerary will be.",
    interests: "Areas of interest",
    constraints: "Special constraints",
    comfort: "Comfort level",
    experience: "Travel experience",
    documents: "Travel documents",
    free_text: "What you absolutely want to do / avoid",
    free_text_placeholder: "E.g.: I want to see Mount Fuji, but avoid tourist crowds...",
    generate: "Compose my trip",
    loading_title: "Your trip is taking shape",
    loading_remaining: "About {n} seconds remaining",
    loading_finalizing: "Finalizing...",
    loading_progress: "Progress",
    loading_note: "Don't close this window — your trip file is being prepared",
    gen_step1: "Analyzing your desires",
    gen_step1_desc: "Destination, dates, vibes, budget...",
    gen_step2: "Composing the itinerary",
    gen_step2_desc: "Day by day, activities, pace...",
    gen_step3: "Practical information",
    gen_step3_desc: "Visa, health, weather, safety...",
    gen_step4: "Budget & bookings",
    gen_step4_desc: "Breakdown by category, useful links...",
    gen_step5: "Diego's final touch",
    gen_step5_desc: "Your expert polishes the last details...",
    error_timeout: "Generation took too long. Please try again.",
    error_default: "Generation error. Please try again.",
    chips: {
      ambiances: ["Beach & sea", "Mountain & nature", "Culture & museums", "Local gastronomy", "Nightlife", "Hiking", "Sports", "Shopping", "Wellness & spa", "Adventure", "Photography", "Local encounters"],
      accommodations: ["3-star hotel", "4-5 star hotel", "Airbnb", "Hostel", "All-inclusive resort", "Eco-lodge", "No preference"],
      paces: ["Very relaxed", "Balanced", "Active", "Intense"],
      gastronomy: ["Local cuisine", "Fine dining", "Street food", "Vegetarian", "Gluten-free", "Halal", "No preference"],
      transport: ["Rental car", "Public transport", "Taxi", "Motorbike", "Bicycle", "Domestic flights", "No preference"],
      interests: ["History & archaeology", "Art & architecture", "Wildlife & flora", "Diving", "Surfing", "Yoga & meditation", "Vineyards", "Festivals", "National parks"],
      constraints: ["Limited mobility", "Food allergy", "Fear of flying", "Pregnant", "No constraints"],
      comforts: ["Budget", "Comfortable", "Premium", "Luxury"],
      experiences: ["Beginner", "Intermediate", "Experienced", "Seasoned traveler"],
      documents: ["Valid passport", "Passport + visa", "Passport to renew", "No documents"],
      budgets: ["Less than €1,000", "€1,000–2,000", "€2,000–4,000", "€4,000–8,000", "€8,000–15,000", "More than €15,000"],
      trip_types: ["Classic vacation", "Honeymoon", "Family", "With friends", "Solo", "Adventure", "City trip", "Wellness"],
    },
  },
  trip: {
    pending_label: "Processing",
    pending_title: "Diego is reviewing your trip",
    pending_desc: "Your itinerary to {dest} is being validated by Diego. He personally checks every detail before granting access.",
    pending_what_label: "What you'll receive",
    pending_feat1: "Expert-validated personalized itinerary",
    pending_feat2: "Realistic and detailed budget",
    pending_feat3: "Essential practical information",
    pending_feat4: "Dedicated travel advisor for your destination (Sérénité plan)",
    pending_note: "You will receive a notification once your trip is ready.",
    expired_title: "Access expired",
    expired_desc: "Access to this trip to {dest} expired 15 days after your return. Your memories, however, are forever.",
  },
  payment: {
    ready_label: "Your trip is ready",
    validated_title: "Diego has validated your itinerary",
    validated_desc: "Choose your plan to unlock your trip to {dest}.",
    per_trip: "per trip",
    popular: "Most popular",
    unlock_btn: "Unlock with {name} — €{price}",
    unlocking: "Redirecting to payment...",
    secure: "Secure payment by Stripe · Immediate access after confirmation",
    error: "Error initiating payment",
    terms_checkbox_pre: "I have read and accept the",
    terms_link: "General Terms of Sale",
    terms_checkbox_post: "— I understand that Voyage-r is an advisory service, not a travel agency, and does not manage my bookings.",
    terms_required: "Please accept the Terms of Sale before continuing.",
  },
  push: {
    enable_btn: "Enable notifications",
    disable_btn: "Disable notifications",
    enabled_toast: "Notifications enabled — you'll be alerted when Diego validates your trip.",
    disabled_toast: "Notifications disabled.",
    denied_toast: "Notifications blocked by browser. Allow them in browser settings.",
  },
};

export default en;
